import React from 'react'

const Entrepreneurship = () => {
  return (
    <div>Entrepreneurship</div>
  )
}

export default Entrepreneurship